const Dashboard = () => {
  return (
    <div className="dashboard">
      <h1>Dashboard</h1>
    </div>
  );
};
export default Dashboard;
